export const featureGates = {
    ADULT_TEAM_PICKLEBALL: 'adult_team_pickleball',
    JUNIOR_TEAM_PICKLEBALL: 'junior_team_pickleball',
    GLOBAL_DROPDOWN_V2: 'global_dropdown_v2',
};
